import {cityList} from "./cities/Cities";
import unknownCity from './img/cities/unknown.jpg';
import React, {PropTypes, Component } from 'react';
import Image from 'react-bootstrap/lib/Image';
import { slug } from './Util';

function cityImage(cityName) {
  var image = unknownCity;
  try {
    return require('./img/cities/' + slug(cityName) + ".jpg");
  } catch (e) {
    // image remains unknown
  }
  return image;
}

class CityImage extends Component {
  static propTypes = {
    city: PropTypes.string.isRequired
  };

  render() {
    const cityName = this.props.city;
    return (<Image alt={cityName + " Image"} className=".img-responsive city-image" src={cityImage(cityName)} />);
  }
}

export default CityImage;



// WEBPACK FOOTER //
// ./src/CityImage.js